import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.css'],
  imports: [NgClass],
})
export class SelectableCardComponent {
  @Input() imageSrc = '';
  @Input() title = '';
  @Input() isHighlighted = false;
  @Input() isSelectable = false;
  @Input() isSelected = false;
}
